import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import Communication from './pages/Communication';
import Chat from './pages/Chat';
import Reporting from './pages/Reporting';
import DataCollection from './pages/DataCollection';
import SurveyAnalytics from './pages/SurveyAnalytics';
import SurveyLinks from './pages/SurveyLinks';
import SurveyPublic from './pages/SurveyPublic';
import UserManagement from './pages/UserManagement';
import CollaboratorsManagement from './pages/CollaboratorsManagement';
import ProjectParticipants from './pages/ProjectParticipants';
import Inventory from './pages/Inventory';
import KnowledgeBase from './pages/KnowledgeBase';
import KPITracking from './pages/KPITracking';
import Profile from './pages/Profile';
import Layout from './components/Layout';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Layout />
                </PrivateRoute>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="projects" element={<Projects />} />
              <Route path="projects/:id" element={<ProjectDetail />} />
              <Route path="communication" element={<Communication />} />
              <Route path="chat" element={<Chat />} />
              <Route path="reporting" element={<Reporting />} />
              <Route path="data-collection" element={<DataCollection />} />
              <Route path="survey-analytics" element={<SurveyAnalytics />} />
              <Route path="survey-links" element={<SurveyLinks />} />
              <Route path="users" element={<UserManagement />} />
              <Route path="collaborators" element={<CollaboratorsManagement />} />
              <Route path="projects/:id/participants" element={<ProjectParticipants />} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="knowledge-base" element={<KnowledgeBase />} />
              <Route path="kpi-tracking" element={<KPITracking />} />
              <Route path="profile" element={<Profile />} />
            </Route>
            <Route path="/survey/:token/:surveyId/:token2" element={<SurveyPublic />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;

